const RECENT_FESTIVAL_PREFIX = "trace_mobile_recent_festival";
const MOBILE_PRODUCTION_TABS = new Set(["equipment", "console", "crew", "logistics"]);

export function mobileFestivalIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/festivals\/([^/?#]+)/);
  return match?.[1] ?? null;
}

export function mobileRecentFestivalKey(organizationId: string | null): string {
  return `${RECENT_FESTIVAL_PREFIX}:${organizationId ?? "all"}`;
}

export function isMobileProductionRoute(pathname: string, search: string): boolean {
  if (!mobileFestivalIdFromPath(pathname)) return false;
  return MOBILE_PRODUCTION_TABS.has(new URLSearchParams(search).get("tab") ?? "");
}

/**
 * Resolve Production without guessing a festival from list order.
 *
 * An explicit festival URL is the strongest context: if the detail is already
 * visible, Production must stay on that exact festival even while organization
 * caches change. Remembered context is weaker and must belong to the active
 * organization's list. Missing or stale memory falls back to the picker.
 */
export function mobileProductionHref({
  currentFestivalId,
  recentFestivalId,
  availableFestivalIds,
}: {
  currentFestivalId: string | null;
  recentFestivalId: string | null;
  availableFestivalIds: readonly string[] | undefined;
}): string {
  if (currentFestivalId) {
    return `/festivals/${currentFestivalId}?tab=equipment`;
  }

  if (recentFestivalId && availableFestivalIds?.includes(recentFestivalId)) {
    return `/festivals/${recentFestivalId}?tab=equipment`;
  }

  return "/festivals";
}
